<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP通知管理 {{ statusText }}</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知類型</span>
                                        </div>
                                        <Select size="small" style="width: 120px;" placeholder="通知類型"
                                                v-model="form.activity">
                                            <Option :value="1">活動通知</Option>
                                            <Option :value="2">系統通知</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem v-show="form.activity == '1'">
                                        <div slot="label" class="form-label">
                                            <span>圖片預覽</span>
                                        </div>
                                        <div class="form-upload-img">
                                            <el-image
                                                style="width: 200px;"
                                                :z-index="99999"
                                                :src="form.image"
                                                :preview-src-list="[form.image]">
                                            </el-image>
                                            <Upload :before-upload="handleBeforeUpload"
                                                    accept="image/png, image/jpg, image/jpeg"
                                                    action="">
                                                <div class="upload-btn">選擇圖片</div>
                                            </Upload>
                                            <div class="upload-tip">格式：PNG、JPG</div>
                                        </div>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem v-show="form.activity == '1'">
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>圖片上傳</span>
                                        </div>
                                        <Input v-model="form.image" style="width:100%" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知標題</span>
                                        </div>

                                        <Input v-model="form.title" style="width:100%" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="18">
                                  <FormItem>
                                      <div slot="label" class="form-label">
                                          <em class="red">* </em>
                                          <span>通知内容</span>
                                      </div>
                                      <!--<Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="通知内容"
                                             v-model="form.content" clearable/>-->
                                      <textarea v-model="form.content" hidden readonly></textarea>
                                      <div id="demo1"></div>
                                  </FormItem>
                                </Col>
                            </Row>
                            
                            
                            <Row :gutter="15">
                                <Col span="15">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知时间</span>
                                        </div>
                                        <Input v-model="form.noticeTime" style="width:100%" placeholder="年-月-日" clearable/>
                                       
                                    </FormItem>
                                </Col>
                            </Row>
                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <!--<em class="red">* </em>-->
                                            <span>跳轉鏈接</span>
                                        </div>
                                        <Input v-model="form.link" style="width:100%" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>
                            
                            <FormItem>
                                <div>
                                    <el-tree
                                        :data="treeData"
                                        show-checkbox
                                        node-key="id"
                                        @check="treeCurrentChange"
                                        :default-expanded-keys="[]"
                                        :default-checked-keys="[]"
                                        :props="defaultProps"
                                    />
                                </div>
                            </FormItem>
                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知開始時間</span>
                                        </div>
                                        <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                                    placeholder="通知開始時間" v-model="form.notiTimeStrat"
                                                    value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
                                                    style='width: 100%;'></DatePicker>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>通知結束時間</span>
                                        </div>
                                        <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                                    placeholder="通知結束時間" v-model="form.notiTimeEnd"
                                                    value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
                                                    style='width: 100%;'></DatePicker>
                                    </FormItem>
                                </Col>
                            </Row>

                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>類型</span>
                                        </div>
                                        <div>
                                            <RadioGroup v-model="form.type">
                                                <Radio :label="1">
                                                    <span>單次</span>
                                                </Radio>
                                                <Radio :label="2">
                                                    <span>無限次數</span>
                                                </Radio>
                                            </RadioGroup>
                                        </div>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>狀態</span>
                                        </div>
                                        <RadioGroup v-model="form.status">
                                            <Radio :label="1">
                                                <span>是</span>
                                            </Radio>
                                            <Radio :label="0">
                                                <span>否</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model="form.weights" max="100" min="1" placeholder="1-100" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm()">{{ statusText }}</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
   import wangEditor from "wangeditor";

   export default {
       data() {
           return {
               uploadFile: {
                   file: '',
                   base64: '',
               },
               pageParam: {},
               detail: {},
               isSubmiting: false,
               statusText: '添加',
               
               form: {
                   activity: 1,
                   title: '',
                   link: '',
                   image: '',
                   content: '',
                   weights: '',
                   status: 0,
                   notiTimeStrat: '',
                   notiTimeEnd: '',
                   type: 1,
                   noticeTime: '',
                   stores: [],
               },
               editor: '',
               defaultProps: {
                   children: 'children',
                   label: 'ReceivingName',
               },
               treeData: [
                   {
                       id: 1,
                       ReceivingName: '门店',
                       children: [],
                   },
                   {
                       id: 2,
                       ReceivingName: '智能柜',
                       children: [],
                   },
               ]
           };
       },
       mounted() {
           const editor = new wangEditor(`#demo1`)
           editor.config.placeholder = '內容'
           editor.config.focus = true
           editor.config.onchange = (newHtml) => {
               this.form.content = newHtml
           }
           
           editor.config.uploadImgServer = 'https://jyb-admin-backend.aoyunltd.com/api/v1/jyb/commodity/order/fileupdate';
           editor.config.uploadFileName = 'file'; //后端接受上传文件的参数名
           editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
           editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
           editor.config.uploadImgHooks = {
               fail: (xhr, editor, result) => {
                   // 插入图片失败回调
                   console.log(result);
               },
               success: (xhr, editor, result) => {
                   // 图片上传成功回调
                   console.log(result);
               },
               timeout: (xhr, editor) => {
                   // 网络超时的回调
                   console.log('網絡超時');
               },
               error: (xhr, editor) => {
                   // 图片上传错误的回调
                   console.log('上傳錯誤');
               },
               //回显
               customInsert: (insertImg, result, editor) => {
                   let app_url = result.data.app_url;
                   let url = result.data.url;
                   let insert_img = app_url + url;
                   insertImg(insert_img);
               },
           };
           
           editor.create()
           this.editor = editor
           // this.editor.txt.html(this.form.content)
           this.getPickAddress()
       },
       methods: {
           //門店 智能柜
           getPickAddress() {
               this.$Rq.requestAuth({
                   url: this.$Api.pickAddress,
                   method: 'get',
                   data: {
                       company_id: 0,
                       type: ''
                   }
               }).then((res) => {
                   if (res.code == 0) {
                       this.treeData[0].children = res.data.data.filter(item => item.Type == 1).filter(it=>it.company_id != 15)
                       this.treeData[1].children = res.data.data.filter(item => item.Type == 2).filter(it=>it.company_id != 15)
                   }
               });
           },
           treeCurrentChange(row,{checkedNodes,checkedKeys,halfCheckedNodes,halfCheckedKeys }) {
               let filterNodes = checkedNodes.filter(item => !item.children)
               this.form.stores = filterNodes.map(item => item.ReceivingID)
           },
           handleBeforeUpload(file)  //上传
           {
               this.uploadFile.file = file;
               this.hanldeImgToBase64();
               return false;
           },
           hanldeImgToBase64() {
               let file = this.uploadFile.file;
               let reader = new FileReader();
               reader.readAsDataURL(file);
               reader.onload = () => {
                   let _base64 = reader.result;
                   this.uploadFile.base64 = _base64;
               };
               this.handleUploadImg();
           },
           handleUploadImg() {
               this.isSubmiting = true;
               let formData = new FormData();
               formData.append('file', this.uploadFile.file);
               this.$Rq.requestAuth({
                   url: this.$Api.uploadImg,
                   method: 'post',
                   data: formData,
                   headers: {
                       'Content-Type': 'multipart/form-data',
                   }
               }).then((res) => {
                   this.isSubmiting = false;
                   if (res.code == 0) {
                       this.form.image = res.data.app_url + res.data.url;
                   } else {
                       this.$Utils.showTipInfo(res.msg);
                   }
               }).catch((err) => {
                   this.isSubmiting = false;
               });
           },
           formatDate(datetime) {
               if (!datetime) return '';
               let dateTime = new Date(datetime);
               let year = dateTime.getFullYear();
               let month = dateTime.getMonth() + 1;
               let date = dateTime.getDate();
               let hour = dateTime.getHours();
               let minute = dateTime.getMinutes();
               let second = dateTime.getSeconds();
               let milliseconds = dateTime.getMilliseconds();
               return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
           },
           formatNum(num) {
               return num < 10 ? '0' + num : num;
           },
           handleBack() {
               this.$router.go(-1);
           },
           handleCheckForm() {
               let form = this.form;
               if (!form.activity) {
                   this.$Utils.showTipInfo('請輸入通知類型');
                   return;
               }
               if (form.activity == 1 && form.image == '') {
                   this.$Utils.showTipInfo('請輸入圖片上傳');
                   return;
               }
               if (form.title === '') {
                   this.$Utils.showTipInfo('請選擇通知标题');
                   return;
               }
               if (form.content === '') {
                   this.$Utils.showTipInfo('請選擇通知內容');
                   return;
               }
               if (form.weights === '') {
                   this.$Utils.showTipInfo('請輸入排序');
                   return;
               }
               if (form.type === '') {
                   this.$Utils.showTipInfo('請選擇彈框次數');
                   return;
               }
               if (form.status === '') {
                   this.$Utils.showTipInfo('請輸入狀態');
                   return;
               }
               if (form.notiTimeStrat === '') {
                   this.$Utils.showTipInfo('請輸入通知開始時間');
                   return;
               }
               if (form.notiTimeEnd === '') {
                   this.$Utils.showTipInfo('請輸入通知結束時間');
                   return;
               }
               if (form.stores?.length === 0) {
                   this.$Utils.showTipInfo('請選擇門店、櫃點');
                   return;
               }
               this.handleSubmit();
           },
           handleSubmit() {
               let form = this.form;
               this.isSubmiting = true;
               if (form.activity == 2) { // 系統通知
                
                   this.$Rq.requestAuth({
                       url: this.$Api.appNotificationManageSet,
                       method: 'post',
                       data: {
                           activity: form.activity,
                           title: form.title,
                           link: form.link,
                           image: "",
                           content: form.content,
                           weights: form.weights,
                           status: Number(form.status),
                           notiTimeStrat: this.formatDate(form.notiTimeStrat),
                           notiTimeEnd: this.formatDate(form.notiTimeEnd),
                           type: form.type,
                           datetext: form.noticeTime,
                           stores: form.stores
                       }
                   }).then((res) => {
                       this.isSubmiting = false;
                    
                       if (res.code == 0) {
                           this.$Utils.showSuccess(res.msg);
                           this.form = {
                               activity: '',
                               title: '',
                               link: '',
                               image: '',
                               content: '',
                               weights: '',
                               status: '',
                               notiTimeStrat: '',
                               notiTimeEnd: '',
                               type: '',
                               noticeTime: '',
                               stores: []
                           }
                       } else {
                           this.$Utils.showTipInfo(res.msg);
                       }
                   }).catch((err) => {
                       this.isSubmiting = false;
                   });
               } else { // 活動通知
                
                   this.$Rq.requestAuth({
                       url: this.$Api.appNotificationManageSet,
                       method: 'post',
                       data: {
                           activity: form.activity,
                           title: form.title,
                           link: form.link,
                           image: form.image,
                           content: form.content,
                           weights: form.weights,
                           status: Number(form.status),
                           notiTimeStrat: this.formatDate(form.notiTimeStrat),
                           notiTimeEnd: this.formatDate(form.notiTimeEnd),
                           type: form.type,
                           datetext: form.noticeTime,
                           stores: form.stores
                       }
                   }).then((res) => {
                       this.isSubmiting = false;
                    
                       if (res.code == 0) {
                           this.$Utils.showSuccess(res.msg);
                           this.form = {
                               activity: '',
                               title: '',
                               link: '',
                               image: '',
                               content: '',
                               weights: '',
                               status: '',
                               notiTimeStrat: '',
                               notiTimeEnd: '',
                               type: '',
                               noticeTime: '',
                               stores: []
                           }
                       } else {
                           this.$Utils.showTipInfo(res.msg);
                       }
                   }).catch((err) => {
                       this.isSubmiting = false;
                   });
               }
           },
       }
   };
</script>
<style>
.el-tree-node>.el-tree-node__children {
    max-height: 500px;
    overflow-y: auto;
}
</style>
<style lang="scss" scoped>
    @import "appNotificationManageAdd.scss";
</style>
